<template>
  <div :class="panelMode ? 'p-3' :'container'">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-2">
        <h3 style="padding-right: 60px">Endre rekkefølgen av produkter i kategorien</h3>
        <div class="dragndrop-info">
        <!-- One sentence per pointer: a finger has to hold first, a mouse does not, and telling
             either one the other's gesture is how «sorteringen virker ikke» starts. -->
        <span class="bo_pointer-fine">Dra og slipp radene for å endre rekkefølgen på hvordan produktene vises for brukere.</span>
        <span class="bo_pointer-coarse">Hold fingeren på en rad til den løfter seg, og dra den dit du vil — slik endrer
          du rekkefølgen på hvordan produktene vises for brukere. Sveiper du raskt, ruller listen i stedet.</span>
        Til slutt trykker du på &laquo;Lagre&raquo; nederst.
      </div>

        <ul id="itemsList" class="bo_categoriesList">
          <li v-for="item in items" :key="item.id" :id="item.id" class="category-row">
            <span class="bo_drag-handle"><font-awesome-icon :icon="['fas', 'grip-lines']"/></span>
            <span class="bo_row-label">{{ item.menuNr }} {{ item.name }}</span>
            <span class="bo_row-move">
              <button type="button" class="icon-btn" aria-label="Flytt opp" @click="moveRowUp($event)"><font-awesome-icon :icon="['fas', 'chevron-up']"/></button>
              <button type="button" class="icon-btn" aria-label="Flytt ned" @click="moveRowDown($event)"><font-awesome-icon :icon="['fas', 'chevron-down']"/></button>
            </span>
          </li>
        </ul>

        <div class="bo_savebtn_container">
          <hr/>
          <button type="button" class="bo_btn" @click="saveOrderOfItems()">Lagre</button>
        </div>
      </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ProductService from "@/services/product/ProductService";
import Sortable from 'sortablejs';
import sortableOptions from "@/util/SortableOptions";
import { moveRowUp, moveRowDown } from "@/util/RowReorder";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false },
    categoryIdProp: { type: String, default: '' }
  },
  emits: ['saved'],
  data() {
    return {
      loading: true,
      items : []
    };
  },
  mounted() {
    this.categoryId = this.categoryIdProp || this.$route.query.categoryId;
    ProductService.getItemsOfCategory(this.categoryId).then(
        (response) => {
          this.items = response.data;
          this.$nextTick(() => {
            let el = document.getElementById('itemsList');
            Sortable.create(el, sortableOptions());
          });

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  methods: {
    // Reordering without a drag — see RowReorder.js for why these move the DOM.
    moveRowUp,
    moveRowDown,

   updateSortOrder(itemId, sortOrder) {
      //console.log(sortOrder + ' : ' + itemId);
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id == itemId) {
          this.items[i].sortOrder = sortOrder;
          break; //Stop this loop, we found it!
        }
      }
    },
    saveOrderOfItems(){
     this.loading = true;

      let listItems = document.getElementById('itemsList').getElementsByTagName('li');
      for (var i = 0; i < listItems.length; i++) {
        let li = listItems[i];
        let itemId = li.getAttribute('id');
        this.updateSortOrder(itemId, i);
      }

      ProductService.sortItems(this.items).then(
          (response) => {
            if(response.data === "SUCCEEDED"){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Updating sortOrder of items failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
